import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import agent, { token } from '../agent'
import { withRouter } from 'react-router-dom'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import QRCode from './widgets/QRCode'
import Nav from './widgets/Nav'
import dateHelper from '../util/dateFormatter'
import LogList from './widgets/LogList'
import _ from 'lodash'
import ReactModal from 'react-modal'
import ListErrors from './widgets/ListErrors'
import role from '../util/role'
import {
  FILE_DETAIL_PAGE_LOADED,
  FILE_DETAIL_PAGE_UNLOADED,
  FILE_DELETE,
  FILE_DOWNLOAD,
  FILE_PERMISSIONS_UPDATE
} from '../constants/actionTypes'
import {
  REACT_APP_FILE_BASEURL,
  REACT_APP_API_ROOT_URL
} from '../constants/config'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

import { BLOCKCHAIN_API_ROOT_URL } from '../constants/config'
import axios from 'axios'

const mapStateToProps = state => ({
  ...state.file,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: FILE_DETAIL_PAGE_LOADED, payload })
  },
  onUnload: () => {
    dispatch({ type: FILE_DETAIL_PAGE_UNLOADED })
  },
  onDelete: (payload, directory) => {
    dispatch({ type: FILE_DELETE, payload, directory })
  },
  onDownload: (payload) => {
    dispatch({ type: FILE_DOWNLOAD, payload })
  },
  onUpdatePermissions: (payload) => {
    dispatch({ type: FILE_PERMISSIONS_UPDATE, payload })
  },
})

class FileDetail extends React.Component {
  constructor() {
    super()
    this.deleteFile = (key, directory) => ev => {
      ev.preventDefault()
      if (window.confirm(i18n.t('file.delete_file_confirm_text'))) {
        const payload = agent.Files.removeFile(key)
        this.props.onDelete(payload, directory)
      }
    }
    this.updatePermissions = () => ev => {
      ev.preventDefault()
      const key = this.props.match.params.key
      const groups = this.state.groups || ''
      const payload = agent.Files.updateFileGroups(key, groups)
      this.props.onUpdatePermissions(payload)
      this.closeModal()
    }
    this.downloadFile = (file) => ev => {
      ev.preventDefault()
      fetch(REACT_APP_API_ROOT_URL + '/files/download/' + file.key, {
        headers: {
          "Authorization": 'Bearer ' + token
        }
      })
        .then(response => {
          response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = file.name;
            a.click();
          });
        });
    }
    this.state = {
      validateRes1: "",
      validateRes2: "",
      validateBlockchainRes: "",
      divHide: "none",
      showModal: false
    };
    // We'll request user data from this API
    this.verifyFile = (file) => ev => {
      let certificate = 0
      this.setState(state => ({
        text: "Validating File Authenticity",
        divHide: "block"
      }));

      // hash file

      this.setState(state => ({
        validateRes1: "1.‌‌ ✅ ‌‌File hash is: " + file.hash
      }));

      this.setState(state => ({
        validateRes2: "2.‌‌ ✅ ‌‌Checking the file hash recordrd on the blockchain..."
      }));

      axios.get(BLOCKCHAIN_API_ROOT_URL + '/transactions/' + file.txid)
        .then(data => {
          if (data.data.transaction == undefined) {
            this.setState(state => ({
              validateBlockchainRes: "3. ❌ The file has not yet been added to the blockchain. Try again later."
            }));
            return
          }
          console.log(data.data.transaction)
          if (data.data.transaction.note == file.hash) {
            this.setState(state => ({
              validateBlockchainRes: "3. ✅ File is on the blockchain (TransactionID: " + data.data.transaction.transaction_id + ") and the local hash matches the blockhain hash (" + file.hash + ")"
            }));
          } else {
            this.setState(state => ({
              validateBlockchainRes: "3. ❌ The file has not yet been added to the blockchain. Try again later."
            }));
          }
        })
    }
  }
  componentWillMount() {
    const key = this.props.match.params.key
    const payload = Promise.all([
      agent.Files.getFileAndIncreaseView(key),
      agent.Files.getFileLogs(key, 1),
      agent.Files.getGroupSimpleList()
    ])

    this.props.onLoad(payload)
  }
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.csvData) {
  //     var data = new Blob([nextProps.csvData], { type: 'text/csv' });
  //     var csvURL = window.URL.createObjectURL(data);
  //     var tempLink = document.createElement('a');
  //     tempLink.href = csvURL;
  //     tempLink.setAttribute('download', `${new Date()}_users.csv`);
  //     tempLink.click();
  //   }
  // }
  componentWillReceiveProps(nextProps) {
    if (nextProps.file && nextProps.file !== this.props.file) {
      Object.assign(this.state, {
        groups: nextProps.file.groups ? _.join(_.map(nextProps.file.groups, function (item) { return item.key }), ',') : null,
      })
    }
  }
  componentWillUnmount() {
    this.props.onUnload()
  }
  getParent = () => {
    return document.querySelector('#content-wrap')
  }
  openModal = () => {
    this.setState({ showModal: true })
  }

  closeModal = () => {
    this.setState({ showModal: false })
  }
  handleCheckboxChange(e) {
    // window.alert(e.target.checked + ' ' + e.target.value)
    let groups = this.state.groups
    let groupArr = groups ? _.split(groups, ',') : []
    if (e.target.checked) {
      groupArr.push(e.target.value)
    } else {
      groupArr = _.pull(groupArr, e.target.value)
    }
    this.setState({ groups: _.join(groupArr, ',') })
  }
  render() {
    let file = this.props.file

    if (!file) {
      return (
        <Loading currentUser={this.props.currentUser} />
      )
    }
    const all_groups = this.props.groups
    const file_groups = file.groups
    const permissions = () => {
      let result = ''
      if (file_groups) {
        let nameArr = []
        for (let i in file_groups) {
          let group = _.find(all_groups, { key: file_groups[i].key })
          if (group) {
            nameArr.push(group.name)
          } else if (file_groups[i].key === 'all') {
            nameArr.push('everyone')
          }
        }
        return _.join(nameArr, ', ')
      }
      return result
    }
    const fileGroupString = this.state.groups
    return (
      <Translation>
        {
          (t) => (
            <div id="main">
              <Nav selected={'files'} currentUser={this.props.currentUser} />
              <div id="content">
                <Header />
                <div id="content-wrap">
                  <div className='box-header'>
                    <span className='header-info'>{t('file.label_created')}: {file.created}</span>
                    <h2><Link to={`/files?directory=${file.directory.key}`}><i className="fad fa-chevron-square-left"></i></Link> {t('file.file_detail_title')}</h2>
                  </div>
                  <dl className='content-details content-details-alt'>
                    <dt>{t('file.label_owner')}</dt>
                    <dd>{file.owner}</dd>
                    <dt>{t('file.label_permissions')}</dt>
                    <dd>{permissions()}</dd>
                    <dt>{t('file.label_file_integrity')}</dt>
                    <dd>{file.hash}</dd>
                    <dt>{t('file.label_size')}</dt>
                    <dd>{(file.size || 0) + ' Byte'}</dd>
                    <dt>{t('file.label_created')}</dt>
                    <dd>{file.created}</dd>
                  </dl>
                  <dl className='content-details'>
                    <dt>{t('file.label_file_name')}</dt>
                    <dd>{file.name}</dd>
                    <dt>{t('file.label_directory')}</dt>
                    <dd><Link to={`/files?directory=${file.directory.key}`}><i className="fad fa-folder"></i> {file.directory.name}</Link></dd>
                    <dt>{t('file.label_views')}</dt>
                    <dd>{file.views}</dd>
                    <dt>{t('file.label_downloads')}</dt>
                    <dd>{file.downloads}</dd>
                    <dt>{t('file.label_file_id')}</dt>
                    <dd>{file.key}</dd>
                  </dl>
                  <hr />
                  <ListErrors errors={this.props.errors} />
                  <div id='tool-belt'>
                    <a href={``} onClick={this.downloadFile(file)} download>{t('file.download_file_button')}</a>
                    <a href={`#`} className='button-sub' onClick={this.verifyFile(file)}>{t('file.verify_file_button')}</a>
                    {
                      role.isFileAdmin(this.props.currentUser.role) || this.props.currentUser.key === file.userkey ?
                        <a href={`#`} className='button-sub' onClick={() => this.openModal()}>{t('file.update_permissions_button')}</a>
                        : null
                    }

                    <div id="verification-box" style={{ display: this.state.divHide }}>
                      <strong>{this.state.text} </strong><br />
                      {this.state.validateRes1}  <br />
                      {this.state.validateRes2}  <br />
                      {this.state.validateBlockchainRes}  <br />
                    </div>
                  </div>
                  <div id='tool-belt-alt'>
                    {role.isFileAdmin(this.props.currentUser.role) || this.props.currentUser.key === file.userkey ?
                      <a href='' onClick={this.deleteFile(file.key, file.directory.key)}>{t('file.delete_file_button')}</a> : null
                    }
                  </div>

                  <ReactModal isOpen={this.state.showModal} parentSelector={this.getParent}>
                    <div id="content-clear">
                      <div className="focus-wrap">
                        <div className='box-header'>
                          <h2>{t('file.update_permissions_title')}</h2>
                        </div>
                        <div className="form-item">
                          <label>{t('file.label_permission')}</label>
                          {
                            all_groups.map(item => {
                              return (
                                <span key={item.key}><input type="checkbox" checked={fileGroupString && fileGroupString.indexOf(item.key) > -1} value={item.key} onChange={this.handleCheckboxChange.bind(this)} />{item.name} <br /></span>
                              )
                            })
                          }
                          <input type="checkbox" value={'all'} checked={fileGroupString && fileGroupString.indexOf('all') > -1} onChange={this.handleCheckboxChange.bind(this)} />Everyone <br />
                        </div>
                        <ListErrors errors={this.props.errors} />
                        <div id='tool-belt'>
                          <a href='#' onClick={this.updatePermissions()}>{t('file.update_button')}</a>
                          <a href='#' className='button-sub' onClick={this.closeModal}>{t('file.close_button')}</a>
                        </div>
                      </div>
                    </div>
                  </ReactModal>

                </div>
                <div id="content-wrap">
                  <div className='box-header'>
                    <h2>{t('file.file_access_title')}</h2>
                  </div>
                  <LogList data={this.props.logs} loading={this.props.loading} />
                </div>
              </div>
            </div>
          )
        }
      </Translation>
    )
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FileDetail))
